import { useCallback, useMemo, useState } from "react"

const deriveInitialValues = (fieldDefs) => fieldDefs
  .reduce((acc, field) => {
    acc[field.name] = field.initialValue || ''
    return acc
  }, {})

/**
 * Controlled form hook
 *
 * Manages form elements and their children inputs. Sets all initial values.
 * Returns an object with input handlers and values for use in a form.
 */
const useForm = (fieldDefs, onSubmit, validateFormFields) => {
  const [formValues, setFormValues] = useState(deriveInitialValues(fieldDefs))
  const [isSubmitting, setIsSubmitting] = useState(false)
  const handleFormChange = useCallback((e) => {
    setFormValues((values) => ({
      ...values,
      [e.target.name]: e.target.value
    }))
  }, [setFormValues])
  const resetFormValues = useCallback(() => {
    setFormValues(deriveInitialValues(fieldDefs))
  }, [setFormValues])
  const handleSubmit = useCallback(async (e) => {
    e.preventDefault()
    setIsSubmitting(true)

    await onSubmit(formValues)

    setIsSubmitting(false)
  }, [formValues])
  const hasError = useMemo(() => validateFormFields ? !validateFormFields(formValues) : false, [formValues])

  return {
    formValues,
    handleFormChange,
    resetFormValues,
    isSubmitting,
    handleSubmit,
    hasError
  }
}

export default useForm
